import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import qs from "qs";
import cx from "classnames";
import styles from "./styles.less";
import moment from "moment";
import { Ribbon } from "../common";

class DealWrraper extends Component {
  getDealRoute = () => {
    const { routing } = this.props;
    const currentQuery = qs.parse(
      routing && routing.location && routing.location.search,
      {
        ignoreQueryPrefix: true
      }
    );
    return currentQuery ? currentQuery.selectedDealId : null;
  };

  getDetailsExpanded = dealId => {
    const { deals } = this.props;
    let dealDetailsExpanded = false;
    deals.forEach(deal => {
      if (deal.id == dealId) {
        dealDetailsExpanded = true;
      }
    });
    return dealDetailsExpanded;
  };

  getSelectedDeal = dealId => {
    const { deals } = this.props;
    let selectedDeal = null;
    deals.forEach(deal => {
      if (deal.id == dealId) {
        selectedDeal = deal;
      }
    });
    return selectedDeal;
  };

  checkIfFastDecosionDeal = deal => {
    const { lastMinuteDaysDeal } = this.props;
    const today = moment();
    const isFastDecision = moment(deal.endDate).diff(
      today.add(lastMinuteDaysDeal, "days")
    );
    return isFastDecision < 0;
  };

  checkIfShowRibbon = deal => {
    const { dealWithMinPrice } = this.props;
    if (deal.id == dealWithMinPrice.id || this.checkIfFastDecosionDeal(deal)) {
      return true;
    }
    return false;
  };

  getRibbonType = deal => {
    const { dealWithMinPrice } = this.props;
    if (deal.id == dealWithMinPrice.id) {
      return 1;
    } else if (this.checkIfFastDecosionDeal(deal)) {
      return 2;
    }
  };

  getRibbonTitle = deal => {
    const { titles } = this.props;
    switch (this.getRibbonType(deal)) {
      case 1:
        return titles.HotDeal;
      case 2:
        return titles.LastMinuteDeal;
      default:
        break;
    }
  };

  renderRibbon = deal => {
    const { isRtl, isMobileView, isIos } = this.props;
    return (
      <div className={styles.dealRibbon}>
        <Ribbon
          text={this.getRibbonTitle(deal)}
          isRtl={isRtl}
          wrapperClassName={cx(styles.dealRibbonWrapper, {
            [styles.dealRibbonWrapperRtl]: isRtl && !isMobileView,
            [styles.dealRibbonWrapperMobileView]: isMobileView && !isRtl,
            [styles.dealRibbonWrapperRtlMobileView]: isRtl && isMobileView,
            [styles.dealRibbonWrapperIosIsShit]: isIos
          })}
          textClassName={cx(styles.dealRibbonWrapperText, {
            [styles.rtl]: isRtl,
            [styles.dealRibbonWrapperTextHotDeal]:
              this.getRibbonType(deal) === 1,
            [styles.dealRibbonWrapperTextFastDesicion]:
              this.getRibbonType(deal) === 2
          })}
          shape="horizontal"
          vertical="top"
        />
      </div>
    );
  };

  render() {
    const {
      deals,
      renderBox,
      onDealClick,
      isMobileView,
      isRtl,
      isIos,
      isIE
    } = this.props;
    return (
      //<Grid.Row className={styles.dealBoxRow}>
      deals.map((deal, index) => (
        <Grid.Column
          className={cx(styles.dealBoxColumn, {
            [styles.rtl]: isRtl,
            [styles.mobileView]: isMobileView,
            [styles.ieIsShit]: isIE,
            [styles.iosIsShit]: isIos
          })}
          mobile={16}
          tablet={7}
          computer={7}
          key={deal.id + "D" + index}
        >
          {this.checkIfShowRibbon(deal) && this.renderRibbon(deal)}
          {renderBox(deal, onDealClick)}
        </Grid.Column>
      ))
      //</Grid.Row>
    );
  }
}

DealWrraper.propTypes = {
  deals: PropTypes.array,
  renderBox: PropTypes.func,
  routing: PropTypes.object,
  onDealClick: PropTypes.func,
  titles: PropTypes.object,
  isMobileView: PropTypes.bool,
  isRtl: PropTypes.bool,
  dealWithMinPrice: PropTypes.object,
  isIos: PropTypes.bool,
  isIE: PropTypes.bool,
  lastMinuteDaysDeal: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default DealWrraper;



// WEBPACK FOOTER //
// ./src/components/DealWrraper/DealWrraper.js